import http from '@/services/http.js';

const JIANYING_API = '/videoapi/jianying';

export const fetchJianyingDevices = async () => {
  const response = await http.get(`${JIANYING_API}/devices`);
  return Array.isArray(response.data.data) ? response.data.data : [];
};

export const updateJianyingDevice = async (deviceId, payload) => {
  const response = await http.put(
    `${JIANYING_API}/devices/${encodeURIComponent(deviceId)}`,
    payload,
  );
  return response.data.data;
};
